// This file is generated. DO NOT EDIT.
export const ErrorCodes = {
    "G-AUTH-003": "Access to resource has been forbidden",
    "G-AUTH-023": "The first enrolled face must be an adult before a child can be added",
    "G-AUTH-024": "The face belongs to a child; repeat the request with the legal guardian's consent",
    "G-AUTH-002": "Device is not trusted",
    "G-AUTH-021": "Confirm the email via the link sent to it before continuing",
    "G-AUTH-012": "Email verification required for underage person",
    "G-AUTH-007": "Given photocode does not have attached any media",
    "G-AUTH-022": "Face not recognized for the existing account, continue the login with the one-time code (otp-request)",
    "G-AUTH-001": "Given credentials are invalid",
    "G-AUTH-009": "Given email address is invalid",
    "G-AUTH-006": "Given photocode is invalid",
    "G-AUTH-008": "Selfie does not contain valid face",
    "G-AUTH-018": "Liveness verification failed",
    "G-AUTH-017": "Liveness session was already used",
    "G-AUTH-013": "No child face found after omitting the parent selfie",
    "G-AUTH-010": "Person on selfie is too young",
    "G-AUTH-011": "Person on selfie is underage",
    "G-AUTH-015": "Recaptcha validation failed",
    "G-AUTH-005": "Access token expired",
    "G-AUTH-014": "Too many attempts, try again later",
    "G-AUTH-020": "With the parent opt-out only one adult guardian is allowed in the batch",
    "G-AUTH-004": "Not authorized to access resource",
    "G-CAMP-003": "Campaign is blocked",
    "G-CAMP-002": "Campaign domain duplicate",
    "G-CAMP-001": "Campaign name duplicate",
    "G-DREG-002": "Account blocked",
    "G-DREG-003": "Printing feature disabled",
    "G-DREG-001": "Invalid PIN",
    "G-DREG-005": "Photographer not assigned",
    "G-DREG-004": "Theme not selected",
    "G-FILE-009": "File uploaded to bucket is missing or corrupted",
    "G-FILE-004": "Invalid uploaded file aspect ratio",
    "G-FILE-010": "Invalid uploaded file checksum",
    "G-FILE-003": "Invalid data payload",
    "G-FILE-002": "Invalid file extension",
    "G-FILE-001": "Invalid file mime",
    "G-FILE-005": "Invalid uploaded file resolution",
    "G-FILE-006": "Invalid uploaded file signature",
    "G-FILE-007": "Invalid upload type",
    "G-FILE-008": "File is to large",
    "G-GERR-006": "Access to resource has been forbidden",
    "G-GERR-003": "Bad request",
    "G-GERR-008": "Resource conflict",
    "G-GERR-001": "Endpoint not found",
    "G-GERR-004": "Internal server error",
    "G-GERR-005": "Invalid request data",
    "G-GERR-007": "Internal server error",
    "G-GERR-002": "Record not found",
    "G-GRSS-001": "Active greenscreen sets limit reached",
    "G-GRTO-005": "This entrance user may only view grotto statuses",
    "G-GRTO-007": "The grotto feature is not licensed for this campaign",
    "G-GRTO-002": "Invalid grotto status, expected available, occupied or unavailable",
    "G-GRTO-001": "No grotto is assigned to this photographer",
    "G-GRTO-006": "Grotto not found",
    "G-GRTO-004": "Another grotto in this campaign already uses this number",
    "G-GRTO-003": "This photographer is already assigned to another grotto",
    "G-IDEMP-001": "Request with this idempotency key has already been processed",
    "G-IDEMP-002": "Failed to store idempotency record",
    "G-INFR-001": "Invalid GoPhoto region",
    "G-JOBE-001": "Job is already being processed",
    "G-JOBE-002": "Job failed with status error",
    "G-JOBE-004": "Job not found",
    "G-JOBE-003": "Job is still being processed",
    "G-ORDR-004": "A higher-tier bundle package is already in the cart",
    "G-ORDR-003": "This item is already in the cart",
    "G-ORDR-002": "Cart is locked for checkout and cannot be modified",
    "G-ORDR-001": "Invalid coupon",
    "G-ORDR-005": "Provided order amount does not match the calculated price",
    "G-PHTO-009": "Photo cannot be modified because it is referenced by existing order lines.",
    "G-PHTO-003": "Photo already exists",
    "G-PHTO-004": "Invalid uploaded photo aspect ratio",
    "G-PHTO-006": "Invalid uploaded photo checksum",
    "G-PHTO-001": "Invalid file type",
    "G-PHTO-007": "Invalid photoset",
    "G-PHTO-005": "Invalid uploaded photo resolution",
    "G-PHTO-002": "Invalid signature",
    "G-PHTO-008": "Photo uploaded to bucket is missing or corrupted",
    "G-PHCO-003": "Photocode generate limit exceeded",
    "G-PHCO-004": "Photocode can't be generated before 9am in this campaign",
    "G-PHCO-001": "Photocode not found",
    "G-PHCO-002": "Photo not found",
    "G-PHCO-005": "Invalid token",
    "G-PHGR-001": "Invalid photographer configuration",
    "G-PROD-001": "Active addon products limit exceeded",
    "G-PROD-003": "Free printing already used in a previous event",
    "G-PROD-002": "Free print configuration is invalid",
    "G-PROD-004": "Product is part of an active product package and can't be deactivated",
    "G-PROD-005": "Only regular products and the digital addon can be part of a product package",
    "G-REPT-001": "Invalid report period, expected daily, weekly or monthly",
    "G-REPT-002": "Report date does not match the requested period (weekly reports start on Monday, monthly reports on the first day of the month)",
    "G-REPT-004": "No report exists for this date",
    "G-REPT-003": "Report for this date has not been generated yet, retry later",
    "G-SF-004": "Device is disabled",
    "G-SF-003": "Device not found",
    "G-SF-001": "Invalid pair code",
    "G-SF-002": "Pair code expired",
    "G-SF-005": "Invalid or expired refresh token",
    "G-SELF-002": "Selfie does not contain valid face",
    "G-SELF-001": "Person on selfie is too young",
    "G-SELF-004": "Person on selfie is underage",
    "G-SELF-003": "Selfie does not contain too many faces",
    "G-USER-001": "User email duplicate",
    "G-VCAM-001": "Camera already recoding",
    "G-VCAM-002": "Camera not responding",
} as const;

export type ErrorCode = keyof typeof ErrorCodes;
